<template>
  <Overtime />
</template>

<script>
import Overtime from './components/OvertimePanel.vue';

export default {
  name: 'App',
  components: {
    Overtime
  }
};
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  margin-top: 30px;
}
</style>
